import { render } from "./NotasFiscais.vue?vue&type=template&id=5e2ac12b&scoped=true"
import script from "./NotasFiscais.vue?vue&type=script&lang=js"
export * from "./NotasFiscais.vue?vue&type=script&lang=js"

import "./NotasFiscais.vue?vue&type=style&index=0&id=5e2ac12b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2ac12b"]])

export default __exports__